import CalendarMonth from '@mui/icons-material/CalendarMonth';
import Home from '@mui/icons-material/Home';
import Info from '@mui/icons-material/Info';
import { RoutePath } from 'features/routing/constants';
import type { SvgIconComponent } from '@mui/icons-material';

export type NavItemConfig = {
  id: string;
  /** i18n key for the label (nav entry and page title alike). */
  labelKey: string;
  Icon: SvgIconComponent;
  /** Without an id → the route pattern; with one → the concrete path. */
  route: (participationId?: string) => string;
};

/** Main nav destinations: the desktop dock renders all of them, mobile splits
 *  them into bottom-nav tabs and the More sheet. */
export const NAV_ITEMS: NavItemConfig[] = [
  { id: 'Home', labelKey: 'Home', Icon: Home, route: RoutePath.Home },
  {
    id: 'Schedule',
    labelKey: 'Schedule',
    Icon: CalendarMonth,
    route: RoutePath.Schedule,
  },
  {
    id: 'StudyInfo',
    labelKey: 'StudyInfo',
    Icon: Info,
    route: RoutePath.StudyInfo,
  },
];

/** Route patterns of every nav destination, for active matching. */
export const NAV_PATTERNS = NAV_ITEMS.map(item => item.route());

/** Mobile bottom-nav tabs. */
export const MOBILE_PRIMARY_ITEMS = NAV_ITEMS.slice(0, 2);

/** Mobile destinations that live in the More sheet instead of a tab. */
export const MOBILE_MORE_ITEMS = NAV_ITEMS.slice(2);
